import { useId } from 'react';
import type { IconProps } from './IconProps';

export function CrownIcon({ className }: IconProps) {
  const gradientId = useId();
  return (
    <svg className={className} width="1em" height="1em" viewBox="0 0 24 24"
      aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={gradientId} x1="0" y1="2" x2="0" y2="22" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--premium-crown-top, #fff0b5)" />
          <stop offset=".48" stopColor="var(--premium-crown-middle, #f2cf78)" />
          <stop offset="1" stopColor="var(--premium-crown-bottom, #c48a35)" />
        </linearGradient>
      </defs>
      <g fill={`url(#${gradientId})`}>
        <path d="m3 7 4.7 3.8L12 4l4.3 6.8L21 7l-2.3 10.4a1 1 0 0 1-1 .8H6.3a1 1 0 0 1-1-.8L3 7Z" />
        <circle cx="3" cy="6" r="1.6" />
        <circle cx="12" cy="3" r="1.7" />
        <circle cx="21" cy="6" r="1.6" />
        <rect x="5.5" y="19.5" width="13" height="2.5" rx="1.25" />
      </g>
      <path d="m12 11 1.7 2.3-1.7 2.3-1.7-2.3Z" fill="#fff3c6" opacity=".8" />
    </svg>
  );
}
